import type { SelectSearchField } from "src/components/Form/Form.types";
import type { SelectLabelProp } from "./system.types";
import type { GridFilterModel } from "@mui/x-data-grid-premium";
import { getSelectFilters } from "./getSelectFilters";
import type { GridLogicOperator } from "@mui/x-data-grid";

export const getSelectFilter = ({
  search,
  labelProp,
  searchField: searchFieldProp,
  filter: filterProp,
  logicOperator,
}: {
  search?: string;
  labelProp?: SelectLabelProp<any>;
  searchField?: SelectSearchField | { (search: string): SelectSearchField };
  filter?: GridFilterModel;
  logicOperator?: GridLogicOperator;
}) => {
  const filterItems = [];

  if (search) {
    const searchField =
      typeof searchFieldProp === "function"
        ? searchFieldProp(search)
        : searchFieldProp;

    filterItems.push(
      ...getSelectFilters({
        searchField,
        searchValue: search,
        labelProp,
      }),
    );
  }

  if (filterProp?.items) {
    filterItems.push(...filterProp.items);
  }

  return {
    logicOperator,
    ...filterProp,
    items: filterItems,
  };
};
